import React from "react";
import { Box, Card, CardContent, Typography, Button } from "@mui/material";
import LockIcon from "@mui/icons-material/Lock";

export default function AccessDenied() {
  const params = new URLSearchParams(window.location.search);
  const email = params.get("email");

  const switchAccount = () => {
    // logout from MS and come back to login
    const postLogout = encodeURIComponent(`${window.location.origin}/login`);
    window.location.href =
      `https://login.microsoftonline.com/common/oauth2/v2.0/logout?post_logout_redirect_uri=${postLogout}`;
  };

  return (
    <Box sx={{ minHeight: "100vh", display: "grid", placeItems: "center", p: 2 }}>
      <Card sx={{ maxWidth: 480 }}>
        <CardContent sx={{ textAlign: "center" }}>
          <LockIcon sx={{ fontSize: 48, mb: 1 }} />
          <Typography variant="h5" gutterBottom>
            Access restricted
          </Typography>
          <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
            {email ? (
              <>
                The account <b>{email}</b> is not authorized.
              </>
            ) : (
              "Your account is not authorized."
            )}
            <br />
         Only accounts approved by the administrator are allowed. 
            If you believe this is a mistake, please contact your administrator.
          </Typography>
          <Box sx={{ display: "flex", gap: 1, justifyContent: "center" }}>
            <Button variant="outlined" href="/">
              Back to Login
            </Button>
            <Button variant="contained" onClick={switchAccount}>
              Use a different account
            </Button>
          </Box>
        </CardContent>
      </Card>
    </Box>
  );
}
